<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-name">
          Olá <span>{{name}}</span>
        </div>
        <div class="c-avatar">
          <img
            src="img/avatars/avatar-root.png"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Meus Dados</strong>
    </CDropdownHeader>
    <CDropdownItem @click="goToProfile">
      <CIcon name="cil-user" /> Editar
    </CDropdownItem>
     <CDropdownDivider/>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Sair
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      name: '',
    }
  },
  created () {
    this.$http.get('/api/profile/')
      .then(res => {
        if (res.status === 200)
        {
          this.name = res.data.user.name.split(' ')[0]
          this.$v.$touch()
        }
      })
      .catch(error => {
          
      });
  },
  methods: {
    logout() {
      this.$http.get('/logout').then(() => {
        this.$router.push({'path': '/login'})
      })
    },
    goToProfile() {
      this.$router.push({name: 'Profile'})
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
  .c-name span {
    text-align: center;
    padding-right: 10px;
    font-weight: 700;
  }
</style>